module.exports = __webpack_public_path__ + "media/fr_ca_s3_Raphael.1dc10e2a.oga";